"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IproIdEmulator = void 0;
// eslint-disable-next-line @typescript-eslint/no-var-requires
const crypto = require('crypto');
const offset = 9000000000;
class IproIdEmulator {
    static emulate(identifier, salt = 'akeneo') {
        const hash = crypto
            .createHash('sha256')
            .update(salt + identifier)
            .digest('hex');
        return offset + parseInt(hash.substring(0, 7), 16);
    }
}
exports.IproIdEmulator = IproIdEmulator;
//# sourceMappingURL=IproIdEmulator.js.map